// extracted by css-extract-rspack-plugin
export default {"originals-fields-group":"s84aSy","originalsFieldsGroup":"s84aSy"};